<div class="content__title j-content__title j-dialog">
  <button class="open_chat-sidebar j-open_chat-sidebar"></button>
  <h1 class="dialog__title j-dialog__title"> {{chatName}} <small *ngIf="chatOccupants"> ({{chatOccupants}}) </small></h1><br>
  <div class="action_links" *ngIf="dialog && dialog.type !== CONSTANTS.DIALOG_TYPES.PUBLICCHAT" >
    <!--<a *ngIf="dialog.type == CONSTANTS.DIALOG_TYPES.GROUPCHAT" class="add_to_dialog j-add_to_dialog" (click)="showUpdateDialog()">
      <i class="material-icons notranslate">person_add</i>
    </a>-->
    <a [title]="'MY_SHIPMENTS.CHAT_DASHBOARD.START_MAIL_CONVERSATION' | translate" (click)="startMailConversation()">
      <i class="material-icons notranslate">mail</i>
    </a>
    <a [title]="'MY_SHIPMENTS.CHAT_DASHBOARD.DELETE_CONVERSATION' | translate" class="quit_fom_dialog_link" (click)="quitFromTheDialog()">
      <i class="material-icons notranslate">delete</i>
    </a>
  </div>
</div>
<div class="notifications j-notifications hidden"></div>

<div class="content__inner j-content__inner">
  <div class="messages j-messages" (scroll)="loadMoreMessages($event)" >
    <ng-container *ngFor="let data of messages">
      <div class="message__wrap" >
        <div class="center">
          {{data[0]}}
        </div>
      </div>
      <app-chat-message *ngFor="let message of data[1];" [message]="message" class="message__wrap" id="{{message._id}}" >
      </app-chat-message>
    </ng-container>
  </div>
  <form (ngSubmit)="onSubmit()" autocomplete="off" class="send_message" name="send_message">
    <div class="message__actions">
      <textarea #field autocapitalize="off" (keydown)="onKeydown($event)"
      (keyup.shift)="shiftDown = false"
      autocomplete="off" autocorrect="off" autofocus
      class="message_feald border rounded" [(ngModel)]="messageField" name="message_feald" placeholder="Type a message"></textarea>
      <label class="attach_btn" for="attach_btn">
        <i class="material-icons notranslate">attachment</i>
        <input class="attach_input" id="attach_btn" (change)="prepareToUpload($event)" name="attach_file" type="file"/>
      </label>
      <button class="send_btn">send</button>
    </div>
    <div class="attachments_preview j-attachments_preview">
      <ng-container *ngFor="let data of attachments">
        <div class="attachment_preview__wrap m-loading" id="{{data.id}}">
          <!--<img class="attachment_preview__item" src="{{data.src}}">
          <a target="_blank" href="{{data.src}}">Download file</a>-->
        </div>
      </ng-container>
    </div>
  </form>
</div>

